import { Connection } from '../lib/connection'

export const addPendingMessage = (message: string) => ({
  type: 'ADD_PENDING_MESSAGE',
  message
})
